import React, { FunctionComponent } from "react";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";

type ConfirmationDailogProps = {
  userType: string;
  ConfirmationDailogClose: () => void;
  UserObject: any;
  status: any;
  onStatusUpdation: (UserObject:any, userType:string, status:any) => void;
};

export const ConfirmationDailog: FunctionComponent<ConfirmationDailogProps> = ({
  UserObject,
  ConfirmationDailogClose,
  userType,
  status,
  onStatusUpdation
}) => {

  return (
    <Dialog
      open
      aria-labelledby="alert-dialog-titles"
      aria-describedby="alert-dialog-descriptions"
    >
      <DialogContent>
        <DialogContentText>
          Would you like to change status of '{UserObject.full_name}'
              </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button type="submit" onClick={() => onStatusUpdation(UserObject, userType, status)}>
          Yes
              </Button>
        <Button onClick={ConfirmationDailogClose}>No</Button>
      </DialogActions>

    </Dialog>
  );
};
